import Auth from '../../../services/auth'
import Contracts from '../../../services/contracts'
import Financial from '../../../services/financial';
import messageDialog from '../../../components/message-dialog';

export default {
  props: ['orderId', 'contractId'],
  data(){
    return {
      loading: undefined,
      reprocessed : false
    }
  },
  mounted: function(){
    this.reprocessed = false;
    if(!Auth.currentUser.onlyOneContract && this.contractId){
      Contracts.getContractByContractId(this.contractId).then(r => {
        this.$store.commit('currentPlanId', r.plan.planId);
      });
    }
  },
  methods:{
    reprocessarPayout() {
      this.reprocessed = true;
      const request = { orderId: this.orderId };
      this.doRequest(request);
    },
    doRequest(req){
      if(Array.isArray(req.orderId)){
        req.allIds = req.orderId;
        req.orderId = 0;
      }
      this.loading = Financial.reprocessPayout(req);
      this.loading.then(() => {
        messageDialog.show({
          title: 'Sucesso',
          message: 'Pagamento realizado com sucesso!',
          type: 'OK'
        }).then(() => {
          this.$emit('reprocessConfirmed', true);
        });
      })
      .catch(erro => {
        this.$emit('close', '');
        this.$emit('reprocessConfirmed', false);
        messageDialog.show({
          title: 'Erro',
          message: erro.data.status.message,
          type: 'OK'
        }).then(() => {
          this.reprocessed = false;
        });
      });
    }
  },
  components:{}
}



// WEBPACK FOOTER //
// ./src/pages/account/request/reprocess.js